import { btnPresets } from "../button/Button"
import { ButtonVariantProps } from "../button/ButtonVariant"

export const navbarButtonPresetStyle: ButtonVariantProps = {
  ...btnPresets.small,
  boxClassName: "px-3 py-2",
}
